import { GatsbyImage } from "gatsby-plugin-image";
import styled from "styled-components";

const IconImage = styled(GatsbyImage)`
  margin: 0 auto;
  height: 150px;
  width: 150px;
  img {
    height: 100%;
  }
`;

const S = {
  IconImage,
};

export default S;
